module.exports = __webpack_public_path__ + "static/webinar-santander@2x-07a7b08bb22d247ac1389631d06d9caa.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/resources/webinar-santander@2x.png
// module id = 2704
// module chunks = 157636680307020